export function Stars({ count, of = 3, className = "" }: { count: number; of?: number; className?: string }) {
  return (
    <span role="img" aria-label={`${count} of ${of} stars`} className={`tracking-wider ${className}`}>
      {Array.from({ length: of }, (_, i) => (
        <span key={i} aria-hidden="true" className={i < count ? "text-sunny" : "text-steel"}>
          ★
        </span>
      ))}
    </span>
  );
}
